<template>
  <div
    class="rounded-full shrink-0 flex items-center justify-center overflow-hidden"
    :class="
      variant === 'initials'
        ? 'bg-primary-100 text-primary-700'
        : 'bg-surface-100'
    "
    :style="{ width: `${elementSize}px`, height: `${elementSize}px` }"
  >
    <img
      v-if="variant === 'avatar' && url"
      :src="url"
      class="h-full w-full object-cover"
    />
    <span
      v-else-if="variant === 'initials'"
      class="font-semibold tracking-wide"
      :style="{ fontSize: `${Math.round(elementSize * 0.35)}px` }"
    >
      {{ initials }}
    </span>
  </div>
</template>

<script setup lang="ts">
type Variant = 'avatar' | 'initials'

withDefaults(
  defineProps<{
    variant: Variant
    url?: string
    initials?: string
    elementSize?: number
  }>(),
  {
    url: undefined,
    initials: undefined,
    elementSize: 32,
  },
)
</script>
